import type { ComponentPropsWithoutRef, ReactNode } from "react";
import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { BlockCardDragOverlay } from "@circle-react-shared/BuilderUI/DragAndDrop/DragOverlay";
import { MobileNotSupportedPanel } from "@circle-react-shared/MobileNotSupportedPanel";

export interface ShellProps extends ComponentPropsWithoutRef<"div"> {
  children: ReactNode;
  className?: string;
}

export const Shell = ({ children, className, ...rest }: ShellProps) => (
  <>
    <div
      className={classNames(
        "text-default hidden h-full grid-rows-[auto_1fr] [grid-auto-columns:auto_1fr] [grid-template-areas:'header_header'_'left-sidebar_main'] lg:grid",
        "divide-primary divide-x divide-y",
        className,
      )}
      data-testid="builder-ui-shell"
      {...rest}
    >
      {children}
    </div>
    <MobileNotSupportedPanel
      className="lg:hidden"
      title={t("builder_ui.mobile_unsupported.title")}
      description={t("builder_ui.mobile_unsupported.description")}
    />
    <BlockCardDragOverlay />
  </>
);
